import { render, staticRenderFns } from "./FormPost.vue?vue&type=template&id=8716b9f4&scoped=true&"
import script from "./FormPost.vue?vue&type=script&lang=js&"
export * from "./FormPost.vue?vue&type=script&lang=js&"
import style0 from "./FormPost.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FormPost.vue?vue&type=style&index=1&id=8716b9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8716b9f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCol,VRow,VStepper,VStepperContent,VStepperStep})
